import controller from './template-detail.controller';
import templateT15 from './templates/template-detail-t15.view.html';
import templateBase from './templates/template-detail-base.view.html';

let TemplateDetailComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative) {
    return templateBase;
  } else {
    if (response.TEMPLATE_DETAIL.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default TemplateDetailComponent;



// WEBPACK FOOTER //
// ./www/components/templates/template-detail/template-detail.component.js